import { ValidateCNPJ } from "../ValidateCNPJ";
import { ValidateCPF } from "../ValidateCPF";

/**
 * Verifica se um número de documento é válido como CPF ou CNPJ.
 * A função aceita apenas documentos com 11 dígitos (CPF) ou 14 dígitos (CNPJ),
 * e delega a validação para funções especializadas (`ValidateCPF` ou `ValidateCNPJ`).
 */
export const validateDocumentNumber = (documentNumber: string): boolean => {
  const isCPF = documentNumber.length === 11;
  const isCNPJ = documentNumber.length === 14;

  if (isCPF) return ValidateCPF(documentNumber);

  if (isCNPJ) return ValidateCNPJ(documentNumber);

  return false;
};
